type CacheItem<T> = {
  value: T
  expiration?: number
}

export const storage = {
  get: <T>(key: string): T | undefined => {
    const item = localStorage.getItem(key)
    if (!item) return undefined
    try {
      const parsed = JSON.parse(item) as CacheItem<T>
      if (parsed.expiration && parsed.expiration < Date.now()) {
        localStorage.removeItem(key)
        return undefined
      }
      return parsed.value
    } catch {
      return undefined
    }
  },

  getRaw: <T>(key: string): CacheItem<T> | undefined => {
    const item = localStorage.getItem(key)
    if (!item) return undefined
    try {
      return JSON.parse(item) as CacheItem<T>
    } catch {
      return undefined
    }
  },

  set: <T>(key: string, value: T, ttl?: number) => {
    const item: CacheItem<T> = {
      value,
      expiration: ttl ? Date.now() + ttl : undefined,
    }
    localStorage.setItem(key, JSON.stringify(item))
  },

  remove: (key: string) => {
    localStorage.removeItem(key)
  },
}
